import { render, staticRenderFns } from "./CountGraph1D.vue?vue&type=template&id=4b704771&scoped=true&"
import script from "./CountGraph1D.vue?vue&type=script&lang=js&"
export * from "./CountGraph1D.vue?vue&type=script&lang=js&"
import style0 from "./CountGraph1D.vue?vue&type=style&index=0&id=4b704771&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b704771",
  null
  
)

export default component.exports